import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable, of, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { Environment } from '../../../environment';
import { Slaughterhouse, GetSlaughterhousesResponse } from '../models/slaughterhouse-service.model';

@Injectable({
  providedIn: 'root',
})
export class SlaughterhouseService {
  private readonly http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  private baseUrl = `${this.env.API_BASE_URL}/service/slaughterhouse/secure`;

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  public getSlaughterhouses(): Observable<Slaughterhouse[] | HttpErrorResponse> {
    return this.http
      .get<GetSlaughterhousesResponse>(`${this.baseUrl}/slaughterhouse?animalType=Broiler`)
      .pipe(
        map((d) => d.slaughterhouses),
        catchError((error: HttpErrorResponse) => {
          if (error.status === 404) {
            return of(<Slaughterhouse[]>[]);
          } else {
            return throwError({ message: error.message });
          }
        }),
      );
  }
}
